import { useEffect, useState } from 'react';

import { SEARCH_DEBOUNCE_MS } from '../../../core/constants/forms';
import { useCombobox } from '../../../common/hooks/use-combobox';
import { useAnimalSearch } from '../contexts/search';

// Typeahead genérico de animales (GET /admin/animals?q=). Reutiliza las clases
// `.search` (clients/styles/search.css, ya en el bundle). `extra` acota (sex, etc.).
export default function AnimalSearch({ onSelect, disabled, placeholder = 'Buscar animal…', extra }) {
    const [text, setText] = useState('');
    const [debounced, setDebounced] = useState('');
    useEffect(() => {
        const t = setTimeout(() => setDebounced(text), SEARCH_DEBOUNCE_MS);
        return () => clearTimeout(t);
    }, [text]);

    const term = debounced.trim();
    const { data, isFetching, error } = useAnimalSearch(debounced, { extra });
    const items = data?.items ?? [];

    const choose = (a) => { setText(a.name || a.number || `#${a.id}`); onSelect?.(a); };
    const cb = useCombobox({ items, onChoose: choose });

    return (
        <div className="search">
            <input
                type="text" className="search__input" value={text} placeholder={placeholder} disabled={disabled}
                role="combobox"
                aria-autocomplete="list"
                aria-expanded={cb.open}
                aria-controls={cb.listId}
                aria-activedescendant={cb.activeId}
                onChange={(e) => { setText(e.target.value); cb.setOpen(true); }}
                onFocus={cb.onFocus} onBlur={cb.onBlur}
                onKeyDown={cb.onKeyDown}
            />
            {cb.open && (
                <div className="search__panel" role="listbox" id={cb.listId}>
                    {term.length < 2 ? (
                        <p className="search__hint">Escribí al menos 2 caracteres.</p>
                    ) : error ? (
                        <p className="search__hint">{error.status === 403 ? 'Sin permiso para buscar animales.' : 'No se pudo buscar.'}</p>
                    ) : !items.length ? (
                        <p className="search__hint">{isFetching ? 'Buscando…' : 'Sin resultados.'}</p>
                    ) : (
                        <div className="search__group">
                            {items.map((a, i) => (
                                <button
                                    key={a.id}
                                    type="button"
                                    id={cb.optionId(i)}
                                    role="option"
                                    aria-selected={cb.activeIndex === i}
                                    className={`search__item ${cb.activeIndex === i ? 'search__item--active' : ''}`}
                                    onMouseDown={cb.onOptionMouseDown(a)}
                                    onMouseEnter={() => cb.setActive(i)}
                                >
                                    <span className="search__item-body">
                                        <span className="search__item-name">{a.name || a.number || `#${a.id}`}</span>
                                        <span className="search__item-sub">{[a.number, a.register, a.race?.name].filter(Boolean).join(' · ') || '—'}</span>
                                    </span>
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
